/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import type {ControlDirectiveHost} from '../interfaces/control';
import {DirectiveDef} from '../interfaces/definition';

export function ÉµÉµControlFeature(passThroughInput: string | null) {
  return (definition: DirectiveDef<unknown>) => {
    definition.controlDef = {
      create: (inst: unknown, host: ControlDirectiveHost): void => {
        (inst as any)?.ÉµngControlCreate(host);
      },
      update: (inst: unknown, host: ControlDirectiveHost): void => {
        (inst as any)?.ÉµngControlUpdate?.(host);
      },
      passThroughInput,
    };
  };
}
